import styled from 'styled-components';
import { IconWithText } from '../icon-with-text/IconWithText';

export const StyledIconWithText = styled(IconWithText)<{ isTextCopied: boolean }>`
  & div {
    color: ${({ theme: { color, palette }, isTextCopied }) =>
      isTextCopied && (palette.mode === 'dark' ? color.success : color.validationGreen)};
  }
`;
